
// @ts-nocheck
import locale__app_locales_bg_json from "../locales/bg.json";
import locale__app_locales_cs_json from "../locales/cs.json";
import locale__app_locales_da_json from "../locales/da.json";
import locale__app_locales_de_json from "../locales/de.json";
import locale__app_locales_de_CH_json from "../locales/de-CH.json";
import locale__app_locales_el_json from "../locales/el.json";
import locale__app_locales_en_json from "../locales/en.json";
import locale__app_locales_es_json from "../locales/es.json";
import locale__app_locales_fr_json from "../locales/fr.json";
import locale__app_locales_hr_json from "../locales/hr.json";
import locale__app_locales_hu_json from "../locales/hu.json";
import locale__app_locales_it_json from "../locales/it.json";
import locale__app_locales_ja_json from "../locales/ja.json";
import locale__app_locales_ko_json from "../locales/ko.json";
import locale__app_locales_lv_json from "../locales/lv.json";
import locale__app_locales_nl_json from "../locales/nl.json";
import locale__app_locales_no_json from "../locales/no.json";
import locale__app_locales_pl_json from "../locales/pl.json";
import locale__app_locales_pt_json from "../locales/pt.json";
import locale__app_locales_ro_json from "../locales/ro.json";
import locale__app_locales_ru_json from "../locales/ru.json";
import locale__app_locales_sk_json from "../locales/sk.json";
import locale__app_locales_sl_json from "../locales/sl.json";
import locale__app_locales_sq_json from "../locales/sq.json";
import locale__app_locales_sr_json from "../locales/sr.json";
import locale__app_locales_sv_json from "../locales/sv.json";
import locale__app_locales_tr_json from "../locales/tr.json";
import locale__app_locales_uk_json from "../locales/uk.json";
import locale__app_locales_zh_json from "../locales/zh.json";


export const localeCodes =  [
  "bg",
  "cs",
  "da",
  "de",
  "de-CH",
  "el",
  "en",
  "es",
  "fr",
  "hr",
  "hu",
  "it",
  "ja",
  "ko",
  "lv",
  "nl",
  "no",
  "pl",
  "pt",
  "ro",
  "ru",
  "sk",
  "sl",
  "sq",
  "sr",
  "sv",
  "tr",
  "uk",
  "zh"
]

export const localeLoaders = {
  "bg": [{ key: "../locales/bg.json", load: () => Promise.resolve(locale__app_locales_bg_json), cache: true }],
  "cs": [{ key: "../locales/cs.json", load: () => Promise.resolve(locale__app_locales_cs_json), cache: true }],
  "da": [{ key: "../locales/da.json", load: () => Promise.resolve(locale__app_locales_da_json), cache: true }],
  "de": [{ key: "../locales/de.json", load: () => Promise.resolve(locale__app_locales_de_json), cache: true }],
  "de-CH": [{ key: "../locales/de-CH.json", load: () => Promise.resolve(locale__app_locales_de_CH_json), cache: true }],
  "el": [{ key: "../locales/el.json", load: () => Promise.resolve(locale__app_locales_el_json), cache: true }],
  "en": [{ key: "../locales/en.json", load: () => Promise.resolve(locale__app_locales_en_json), cache: true }],
  "es": [{ key: "../locales/es.json", load: () => Promise.resolve(locale__app_locales_es_json), cache: true }],
  "fr": [{ key: "../locales/fr.json", load: () => Promise.resolve(locale__app_locales_fr_json), cache: true }],
  "hr": [{ key: "../locales/hr.json", load: () => Promise.resolve(locale__app_locales_hr_json), cache: true }],
  "hu": [{ key: "../locales/hu.json", load: () => Promise.resolve(locale__app_locales_hu_json), cache: true }],
  "it": [{ key: "../locales/it.json", load: () => Promise.resolve(locale__app_locales_it_json), cache: true }],
  "ja": [{ key: "../locales/ja.json", load: () => Promise.resolve(locale__app_locales_ja_json), cache: true }],
  "ko": [{ key: "../locales/ko.json", load: () => Promise.resolve(locale__app_locales_ko_json), cache: true }],
  "lv": [{ key: "../locales/lv.json", load: () => Promise.resolve(locale__app_locales_lv_json), cache: true }],
  "nl": [{ key: "../locales/nl.json", load: () => Promise.resolve(locale__app_locales_nl_json), cache: true }],
  "no": [{ key: "../locales/no.json", load: () => Promise.resolve(locale__app_locales_no_json), cache: true }],
  "pl": [{ key: "../locales/pl.json", load: () => Promise.resolve(locale__app_locales_pl_json), cache: true }],
  "pt": [{ key: "../locales/pt.json", load: () => Promise.resolve(locale__app_locales_pt_json), cache: true }],
  "ro": [{ key: "../locales/ro.json", load: () => Promise.resolve(locale__app_locales_ro_json), cache: true }],
  "ru": [{ key: "../locales/ru.json", load: () => Promise.resolve(locale__app_locales_ru_json), cache: true }],
  "sk": [{ key: "../locales/sk.json", load: () => Promise.resolve(locale__app_locales_sk_json), cache: true }],
  "sl": [{ key: "../locales/sl.json", load: () => Promise.resolve(locale__app_locales_sl_json), cache: true }],
  "sq": [{ key: "../locales/sq.json", load: () => Promise.resolve(locale__app_locales_sq_json), cache: true }],
  "sr": [{ key: "../locales/sr.json", load: () => Promise.resolve(locale__app_locales_sr_json), cache: true }],
  "sv": [{ key: "../locales/sv.json", load: () => Promise.resolve(locale__app_locales_sv_json), cache: true }],
  "tr": [{ key: "../locales/tr.json", load: () => Promise.resolve(locale__app_locales_tr_json), cache: true }],
  "uk": [{ key: "../locales/uk.json", load: () => Promise.resolve(locale__app_locales_uk_json), cache: true }],
  "zh": [{ key: "../locales/zh.json", load: () => Promise.resolve(locale__app_locales_zh_json), cache: true }]
}

export const vueI18nConfigs = [
  
]

export const nuxtI18nOptions = {
  "experimental": {
    "localeDetector": "",
    "switchLocalePathLinkSSR": false,
    "autoImportTranslationFunctions": false
  },
  "bundle": {
    "compositionOnly": true,
    "runtimeOnly": false,
    "fullInstall": true,
    "dropMessageCompiler": false
  },
  "compilation": {
    "jit": true,
    "strictMessage": true,
    "escapeHtml": false
  },
  "customBlocks": {
    "defaultSFCLang": "json",
    "globalSFCScope": false
  },
  "vueI18n": "",
  "locales": [
    {
      "code": "bg",
      "name": "Bulgarian",
      "iso": "bg-BG",
      "files": [
        "locales/bg.json"
      ]
    },
    {
      "code": "cs",
      "name": "Czech",
      "iso": "cs-CZ",
      "files": [
        "locales/cs.json"
      ]
    },
    {
      "code": "da",
      "name": "Danish",
      "iso": "da-DK",
      "files": [
        "locales/da.json"
      ]
    },
    {
      "code": "de",
      "name": "German",
      "iso": "de-DE",
      "files": [
        "locales/de.json"
      ]
    },
    {
      "code": "de-CH",
      "name": "German (Switzerland)",
      "iso": "de-CH",
      "files": [
        "locales/de-CH.json"
      ]
    },
    {
      "code": "el",
      "name": "Greek",
      "iso": "el-GR",
      "files": [
        "locales/el.json"
      ]
    },
    {
      "code": "en",
      "name": "English",
      "iso": "en-US",
      "files": [
        "locales/en.json"
      ]
    },
    {
      "code": "es",
      "name": "Spanish",
      "iso": "es-ES",
      "files": [
        "locales/es.json"
      ]
    },
    {
      "code": "fr",
      "name": "French",
      "iso": "fr-FR",
      "files": [
        "locales/fr.json"
      ]
    },
    {
      "code": "hr",
      "name": "Croatian",
      "iso": "hr-HR",
      "files": [
        "locales/hr.json"
      ]
    },
    {
      "code": "hu",
      "name": "Hungarian",
      "iso": "hu-HU",
      "files": [
        "locales/hu.json"
      ]
    },
    {
      "code": "it",
      "name": "Italian",
      "iso": "it-IT",
      "files": [
        "locales/it.json"
      ]
    },
    {
      "code": "ja",
      "name": "Japanese",
      "iso": "ja-JP",
      "files": [
        "locales/ja.json"
      ]
    },
    {
      "code": "ko",
      "name": "Korean",
      "iso": "ko-KR",
      "files": [
        "locales/ko.json"
      ]
    },
    {
      "code": "lv",
      "name": "Latvian",
      "iso": "lv-LV",
      "files": [
        "locales/lv.json"
      ]
    },
    {
      "code": "nl",
      "name": "Dutch",
      "iso": "nl-NL",
      "files": [
        "locales/nl.json"
      ]
    },
    {
      "code": "no",
      "name": "Norwegian",
      "iso": "no-NO",
      "files": [
        "locales/no.json"
      ]
    },
    {
      "code": "pl",
      "name": "Polish",
      "iso": "pl-PL",
      "files": [
        "locales/pl.json"
      ]
    },
    {
      "code": "pt",
      "name": "Portuguese",
      "iso": "pt-PT",
      "files": [
        "locales/pt.json"
      ]
    },
    {
      "code": "ro",
      "name": "Romanian",
      "iso": "ro-RO",
      "files": [
        "locales/ro.json"
      ]
    },
    {
      "code": "ru",
      "name": "Russian",
      "iso": "ru-RU",
      "files": [
        "locales/ru.json"
      ]
    },
    {
      "code": "sk",
      "name": "Slovak",
      "iso": "sk-SK",
      "files": [
        "locales/sk.json"
      ]
    },
    {
      "code": "sl",
      "name": "Slovenian",
      "iso": "sl-SI",
      "files": [
        "locales/sl.json"
      ]
    },
    {
      "code": "sq",
      "name": "Albanian",
      "iso": "sq-AL",
      "files": [
        "locales/sq.json"
      ]
    },
    {
      "code": "sr",
      "name": "Serbian",
      "iso": "sr-RS",
      "files": [
        "locales/sr.json"
      ]
    },
    {
      "code": "sv",
      "name": "Swedish",
      "iso": "sv-SE",
      "files": [
        "locales/sv.json"
      ]
    },
    {
      "code": "tr",
      "name": "Turkish",
      "iso": "tr-TR",
      "files": [
        "locales/tr.json"
      ]
    },
    {
      "code": "uk",
      "name": "Ukrainian",
      "iso": "uk-UA",
      "files": [
        "locales/uk.json"
      ]
    },
    {
      "code": "zh",
      "name": "Chinese",
      "iso": "zh-CN",
      "files": [
        "locales/zh.json"
      ]
    }
  ],
  "defaultLocale": "en",
  "defaultDirection": "ltr",
  "routesNameSeparator": "___",
  "trailingSlash": false,
  "defaultLocaleRouteNameSuffix": "default",
  "strategy": "no_prefix",
  "lazy": false,
  "langDir": "./locales",
  "detectBrowserLanguage": {
    "alwaysRedirect": false,
    "cookieCrossOrigin": false,
    "cookieDomain": null,
    "cookieKey": "i18n_redirected",
    "cookieSecure": false,
    "fallbackLocale": "",
    "redirectOn": "root",
    "useCookie": false
  },
  "differentDomains": false,
  "baseUrl": "",
  "dynamicRouteParams": false,
  "customRoutes": "page",
  "pages": {},
  "skipSettingLocaleOnNavigate": false,
  "types": "composition",
  "debug": false,
  "parallelPlugin": false,
  "i18nModules": []
}

export const normalizedLocales = [
  {
    "code": "bg",
    "name": "Bulgarian",
    "iso": "bg-BG",
    "files": [
      {
        "path": "locales/bg.json"
      }
    ]
  },
  {
    "code": "cs",
    "name": "Czech",
    "iso": "cs-CZ",
    "files": [
      {
        "path": "locales/cs.json"
      }
    ]
  },
  {
    "code": "da",
    "name": "Danish",
    "iso": "da-DK",
    "files": [
      {
        "path": "locales/da.json"
      }
    ]
  },
  {
    "code": "de",
    "name": "German",
    "iso": "de-DE",
    "files": [
      {
        "path": "locales/de.json"
      }
    ]
  },
  {
    "code": "de-CH",
    "name": "German (Switzerland)",
    "iso": "de-CH",
    "files": [
      {
        "path": "locales/de-CH.json"
      }
    ]
  },
  {
    "code": "el",
    "name": "Greek",
    "iso": "el-GR",
    "files": [
      {
        "path": "locales/el.json"
      }
    ]
  },
  {
    "code": "en",
    "name": "English",
    "iso": "en-US",
    "files": [
      {
        "path": "locales/en.json"
      }
    ]
  },
  {
    "code": "es",
    "name": "Spanish",
    "iso": "es-ES",
    "files": [
      {
        "path": "locales/es.json"
      }
    ]
  },
  {
    "code": "fr",
    "name": "French",
    "iso": "fr-FR",
    "files": [
      {
        "path": "locales/fr.json"
      }
    ]
  },
  {
    "code": "hr",
    "name": "Croatian",
    "iso": "hr-HR",
    "files": [
      {
        "path": "locales/hr.json"
      }
    ]
  },
  {
    "code": "hu",
    "name": "Hungarian",
    "iso": "hu-HU",
    "files": [
      {
        "path": "locales/hu.json"
      }
    ]
  },
  {
    "code": "it",
    "name": "Italian",
    "iso": "it-IT",
    "files": [
      {
        "path": "locales/it.json"
      }
    ]
  },
  {
    "code": "ja",
    "name": "Japanese",
    "iso": "ja-JP",
    "files": [
      {
        "path": "locales/ja.json"
      }
    ]
  },
  {
    "code": "ko",
    "name": "Korean",
    "iso": "ko-KR",
    "files": [
      {
        "path": "locales/ko.json"
      }
    ]
  },
  {
    "code": "lv",
    "name": "Latvian",
    "iso": "lv-LV",
    "files": [
      {
        "path": "locales/lv.json"
      }
    ]
  },
  {
    "code": "nl",
    "name": "Dutch",
    "iso": "nl-NL",
    "files": [
      {
        "path": "locales/nl.json"
      }
    ]
  },
  {
    "code": "no",
    "name": "Norwegian",
    "iso": "no-NO",
    "files": [
      {
        "path": "locales/no.json"
      }
    ]
  },
  {
    "code": "pl",
    "name": "Polish",
    "iso": "pl-PL",
    "files": [
      {
        "path": "locales/pl.json"
      }
    ]
  },
  {
    "code": "pt",
    "name": "Portuguese",
    "iso": "pt-PT",
    "files": [
      {
        "path": "locales/pt.json"
      }
    ]
  },
  {
    "code": "ro",
    "name": "Romanian",
    "iso": "ro-RO",
    "files": [
      {
        "path": "locales/ro.json"
      }
    ]
  },
  {
    "code": "ru",
    "name": "Russian",
    "iso": "ru-RU",
    "files": [
      {
        "path": "locales/ru.json"
      }
    ]
  },
  {
    "code": "sk",
    "name": "Slovak",
    "iso": "sk-SK",
    "files": [
      {
        "path": "locales/sk.json"
      }
    ]
  },
  {
    "code": "sl",
    "name": "Slovenian",
    "iso": "sl-SI",
    "files": [
      {
        "path": "locales/sl.json"
      }
    ]
  },
  {
    "code": "sq",
    "name": "Albanian",
    "iso": "sq-AL",
    "files": [
      {
        "path": "locales/sq.json"
      }
    ]
  },
  {
    "code": "sr",
    "name": "Serbian",
    "iso": "sr-RS",
    "files": [
      {
        "path": "locales/sr.json"
      }
    ]
  },
  {
    "code": "sv",
    "name": "Swedish",
    "iso": "sv-SE",
    "files": [
      {
        "path": "locales/sv.json"
      }
    ]
  },
  {
    "code": "tr",
    "name": "Turkish",
    "iso": "tr-TR",
    "files": [
      {
        "path": "locales/tr.json"
      }
    ]
  },
  {
    "code": "uk",
    "name": "Ukrainian",
    "iso": "uk-UA",
    "files": [
      {
        "path": "locales/uk.json"
      }
    ]
  },
  {
    "code": "zh",
    "name": "Chinese",
    "iso": "zh-CN",
    "files": [
      {
        "path": "locales/zh.json"
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false

export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18n"
export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
